/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      name
      contact
      email
      status
      usage
      internalname
      groups
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      alerts {
        nextToken
        __typename
      }
      trackers
      campaigns {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      name
      contact
      email
      status
      usage
      internalname
      groups
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      alerts {
        nextToken
        __typename
      }
      trackers
      campaigns {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      name
      contact
      email
      status
      usage
      internalname
      groups
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      alerts {
        nextToken
        __typename
      }
      trackers
      campaigns {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      firstname
      lastname
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      firstname
      lastname
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      firstname
      lastname
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createAlert = /* GraphQL */ `
  mutation CreateAlert(
    $input: CreateAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    createAlert(input: $input, condition: $condition) {
      id
      name
      agent
      conversation
      campaign
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      risk
      readBy
      createdAt
      updatedAt
      companyAlertsId
      __typename
    }
  }
`;
export const updateAlert = /* GraphQL */ `
  mutation UpdateAlert(
    $input: UpdateAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    updateAlert(input: $input, condition: $condition) {
      id
      name
      agent
      conversation
      campaign
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      risk
      readBy
      createdAt
      updatedAt
      companyAlertsId
      __typename
    }
  }
`;
export const deleteAlert = /* GraphQL */ `
  mutation DeleteAlert(
    $input: DeleteAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    deleteAlert(input: $input, condition: $condition) {
      id
      name
      agent
      conversation
      campaign
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      risk
      readBy
      createdAt
      updatedAt
      companyAlertsId
      __typename
    }
  }
`;
export const createAgent = /* GraphQL */ `
  mutation CreateAgent(
    $input: CreateAgentInput!
    $condition: ModelAgentConditionInput
  ) {
    createAgent(input: $input, condition: $condition) {
      id
      name
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      campaigns {
        nextToken
        __typename
      }
      conversation {
        nextToken
        __typename
      }
      sftpProcess {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyAgentsId
      __typename
    }
  }
`;
export const updateAgent = /* GraphQL */ `
  mutation UpdateAgent(
    $input: UpdateAgentInput!
    $condition: ModelAgentConditionInput
  ) {
    updateAgent(input: $input, condition: $condition) {
      id
      name
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      campaigns {
        nextToken
        __typename
      }
      conversation {
        nextToken
        __typename
      }
      sftpProcess {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyAgentsId
      __typename
    }
  }
`;
export const deleteAgent = /* GraphQL */ `
  mutation DeleteAgent(
    $input: DeleteAgentInput!
    $condition: ModelAgentConditionInput
  ) {
    deleteAgent(input: $input, condition: $condition) {
      id
      name
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      campaigns {
        nextToken
        __typename
      }
      conversation {
        nextToken
        __typename
      }
      sftpProcess {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyAgentsId
      __typename
    }
  }
`;
export const createCampaign = /* GraphQL */ `
  mutation CreateCampaign(
    $input: CreateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    createCampaign(input: $input, condition: $condition) {
      id
      name
      startdate
      enddate
      active
      pinned
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      trackers
      type
      direction
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      groups
      s3Key
      createdAt
      updatedAt
      companyCampaignsId
      __typename
    }
  }
`;
export const updateCampaign = /* GraphQL */ `
  mutation UpdateCampaign(
    $input: UpdateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    updateCampaign(input: $input, condition: $condition) {
      id
      name
      startdate
      enddate
      active
      pinned
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      trackers
      type
      direction
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      groups
      s3Key
      createdAt
      updatedAt
      companyCampaignsId
      __typename
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  mutation DeleteCampaign(
    $input: DeleteCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    deleteCampaign(input: $input, condition: $condition) {
      id
      name
      startdate
      enddate
      active
      pinned
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      trackers
      type
      direction
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      groups
      s3Key
      createdAt
      updatedAt
      companyCampaignsId
      __typename
    }
  }
`;
export const createConversation = /* GraphQL */ `
  mutation CreateConversation(
    $input: CreateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    createConversation(input: $input, condition: $condition) {
      id
      name
      agent
      agenttag
      archive
      startdate
      sentiment
      enddate
      bookmarks
      duration
      VS
      symblstatus
      symbljobid
      symblconversationid
      alertcount
      transcript
      topics
      analytics
      questions
      summary
      trackersdetected
      file
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      groups
      s3Key
      message
      agentId {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      createdAt
      updatedAt
      agentConversationId
      campaignConversationsId
      __typename
    }
  }
`;
export const updateConversation = /* GraphQL */ `
  mutation UpdateConversation(
    $input: UpdateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    updateConversation(input: $input, condition: $condition) {
      id
      name
      agent
      agenttag
      archive
      startdate
      sentiment
      enddate
      bookmarks
      duration
      VS
      symblstatus
      symbljobid
      symblconversationid
      alertcount
      transcript
      topics
      analytics
      questions
      summary
      trackersdetected
      file
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      groups
      s3Key
      message
      agentId {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      createdAt
      updatedAt
      agentConversationId
      campaignConversationsId
      __typename
    }
  }
`;
export const deleteConversation = /* GraphQL */ `
  mutation DeleteConversation(
    $input: DeleteConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    deleteConversation(input: $input, condition: $condition) {
      id
      name
      agent
      agenttag
      archive
      startdate
      sentiment
      enddate
      bookmarks
      duration
      VS
      symblstatus
      symbljobid
      symblconversationid
      alertcount
      transcript
      topics
      analytics
      questions
      summary
      trackersdetected
      file
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      groups
      s3Key
      message
      agentId {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      createdAt
      updatedAt
      agentConversationId
      campaignConversationsId
      __typename
    }
  }
`;
export const createTopic = /* GraphQL */ `
  mutation CreateTopic(
    $input: CreateTopicInput!
    $condition: ModelTopicConditionInput
  ) {
    createTopic(input: $input, condition: $condition) {
      id
      conversation_id
      topic
      topics_with_sentiment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTopic = /* GraphQL */ `
  mutation UpdateTopic(
    $input: UpdateTopicInput!
    $condition: ModelTopicConditionInput
  ) {
    updateTopic(input: $input, condition: $condition) {
      id
      conversation_id
      topic
      topics_with_sentiment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTopic = /* GraphQL */ `
  mutation DeleteTopic(
    $input: DeleteTopicInput!
    $condition: ModelTopicConditionInput
  ) {
    deleteTopic(input: $input, condition: $condition) {
      id
      conversation_id
      topic
      topics_with_sentiment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSFTPProcessQueue = /* GraphQL */ `
  mutation CreateSFTPProcessQueue(
    $input: CreateSFTPProcessQueueInput!
    $condition: ModelSFTPProcessQueueConditionInput
  ) {
    createSFTPProcessQueue(input: $input, condition: $condition) {
      id
      agentId {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      conversationId
      campaignKey
      createdAt
      endProcessTime
      fileName
      hitType
      processed
      queuedForProcessing
      s3Key
      startProcessTime
      updatedAt
      metaData {
        nextToken
        __typename
      }
      agentSftpProcessId
      __typename
    }
  }
`;
export const updateSFTPProcessQueue = /* GraphQL */ `
  mutation UpdateSFTPProcessQueue(
    $input: UpdateSFTPProcessQueueInput!
    $condition: ModelSFTPProcessQueueConditionInput
  ) {
    updateSFTPProcessQueue(input: $input, condition: $condition) {
      id
      agentId {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      conversationId
      campaignKey
      createdAt
      endProcessTime
      fileName
      hitType
      processed
      queuedForProcessing
      s3Key
      startProcessTime
      updatedAt
      metaData {
        nextToken
        __typename
      }
      agentSftpProcessId
      __typename
    }
  }
`;
export const deleteSFTPProcessQueue = /* GraphQL */ `
  mutation DeleteSFTPProcessQueue(
    $input: DeleteSFTPProcessQueueInput!
    $condition: ModelSFTPProcessQueueConditionInput
  ) {
    deleteSFTPProcessQueue(input: $input, condition: $condition) {
      id
      agentId {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      conversationId
      campaignKey
      createdAt
      endProcessTime
      fileName
      hitType
      processed
      queuedForProcessing
      s3Key
      startProcessTime
      updatedAt
      metaData {
        nextToken
        __typename
      }
      agentSftpProcessId
      __typename
    }
  }
`;
export const createMetaDataRelatedToSFTPFile = /* GraphQL */ `
  mutation CreateMetaDataRelatedToSFTPFile(
    $input: CreateMetaDataRelatedToSFTPFileInput!
    $condition: ModelMetaDataRelatedToSFTPFileConditionInput
  ) {
    createMetaDataRelatedToSFTPFile(input: $input, condition: $condition) {
      id
      recordingId
      campaignName
      teamName
      sftpId {
        id
        conversationId
        campaignKey
        createdAt
        endProcessTime
        fileName
        hitType
        processed
        queuedForProcessing
        s3Key
        startProcessTime
        updatedAt
        agentSftpProcessId
        __typename
      }
      direction
      customerId
      callDate
      startTime
      endTime
      durationInSec
      endedBy
      outcomeName
      createdAt
      updatedAt
      sFTPProcessQueueMetaDataId
      __typename
    }
  }
`;
export const updateMetaDataRelatedToSFTPFile = /* GraphQL */ `
  mutation UpdateMetaDataRelatedToSFTPFile(
    $input: UpdateMetaDataRelatedToSFTPFileInput!
    $condition: ModelMetaDataRelatedToSFTPFileConditionInput
  ) {
    updateMetaDataRelatedToSFTPFile(input: $input, condition: $condition) {
      id
      recordingId
      campaignName
      teamName
      sftpId {
        id
        conversationId
        campaignKey
        createdAt
        endProcessTime
        fileName
        hitType
        processed
        queuedForProcessing
        s3Key
        startProcessTime
        updatedAt
        agentSftpProcessId
        __typename
      }
      direction
      customerId
      callDate
      startTime
      endTime
      durationInSec
      endedBy
      outcomeName
      createdAt
      updatedAt
      sFTPProcessQueueMetaDataId
      __typename
    }
  }
`;
export const deleteMetaDataRelatedToSFTPFile = /* GraphQL */ `
  mutation DeleteMetaDataRelatedToSFTPFile(
    $input: DeleteMetaDataRelatedToSFTPFileInput!
    $condition: ModelMetaDataRelatedToSFTPFileConditionInput
  ) {
    deleteMetaDataRelatedToSFTPFile(input: $input, condition: $condition) {
      id
      recordingId
      campaignName
      teamName
      sftpId {
        id
        conversationId
        campaignKey
        createdAt
        endProcessTime
        fileName
        hitType
        processed
        queuedForProcessing
        s3Key
        startProcessTime
        updatedAt
        agentSftpProcessId
        __typename
      }
      direction
      customerId
      callDate
      startTime
      endTime
      durationInSec
      endedBy
      outcomeName
      createdAt
      updatedAt
      sFTPProcessQueueMetaDataId
      __typename
    }
  }
`;
export const createAgentsandcampaigns = /* GraphQL */ `
  mutation CreateAgentsandcampaigns(
    $input: CreateAgentsandcampaignsInput!
    $condition: ModelAgentsandcampaignsConditionInput
  ) {
    createAgentsandcampaigns(input: $input, condition: $condition) {
      id
      agentId
      campaignId
      agent {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAgentsandcampaigns = /* GraphQL */ `
  mutation UpdateAgentsandcampaigns(
    $input: UpdateAgentsandcampaignsInput!
    $condition: ModelAgentsandcampaignsConditionInput
  ) {
    updateAgentsandcampaigns(input: $input, condition: $condition) {
      id
      agentId
      campaignId
      agent {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAgentsandcampaigns = /* GraphQL */ `
  mutation DeleteAgentsandcampaigns(
    $input: DeleteAgentsandcampaignsInput!
    $condition: ModelAgentsandcampaignsConditionInput
  ) {
    deleteAgentsandcampaigns(input: $input, condition: $condition) {
      id
      agentId
      campaignId
      agent {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        direction
        groups
        s3Key
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
